import React from "react";
import firebase from "../../firebase";
import config from "../../config/config";

class RegistrationForm extends React.Component {
    constructor(props) {
        super(props);
        this.ref = firebase.firestore().collection(config.registerUserPath);

        this.state = {
            isLoading: false,
            fullName: '',
            phoneNumber: '',
            emailId: '',
            joinType: '',
            cityState: '',
            errors: {},
            formIsValid: true,
            errorMsg: 'Please fill all the details',
            successMsg: ''
        };
    }

    saveDetails = () => {
        if(this.validateForm()) {
            this.setState({
                isLoading: true,
            });
            this.ref.add({
                fullName: this.state.fullName,
                phoneNumber: this.state.phoneNumber,
                emailId: this.state.emailId,
                joinType: this.state.joinType,
                cityState: this.state.cityState
            }).then((docRef) => {
                this.setState({
                    isLoading: false,
                    fullName: '',
                    phoneNumber: '',
                    emailId: '',
                    joinType: '',
                    cityState: '',
                    successMsg: 'Your details are saved successfully. Thanks for showing interest in joining us. We will reach out to you personally to take things forward.'
                });
            })
                .catch((error) => {
                    console.error("Error saving details: ", error);
                    this.setState({
                        isLoading: false,
                        errorMsg: 'Error saving details, please try again later'
                    });
                });
        }
    };

    handleInputChange = event => {
        this.setState({[event.target.id]: event.target.value});
    };

    validateForm() {
        let formIsValid = true;
        let errors = {};

        if(this.state.fullName === ''){
            formIsValid = false;
            errors["fullName"] = "*Please enter your Full Name";
        } else {
            if(!this.state.fullName.match(/^[a-zA-Z ]*$/)){
                formIsValid = false;
                errors["fullName"] = "*Please enter alphabet characters only";
            }
        }

        if(this.state.emailId === ''){
            formIsValid = false;
            errors["emailId"] = "*Please enter your Email id";
        } else {
            const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(this.state.emailId)) {
                formIsValid = false;
                errors["emailId"] = "*Please enter valid Email id";
            }
        }

        if(this.state.phoneNumber === ''){
            formIsValid = false;
            errors["phoneNumber"] = "*Please enter your Phone Number";
        } else {
            if (!this.state.phoneNumber.match(/^[0-9]{10}$/)) {
                formIsValid = false;
                errors["phoneNumber"] = "*Please enter valid 10 digit phone number";
            }
        }

        if(this.state.joinType === ''){
            formIsValid = false;
            errors["joinType"] = "*Please select your type of joining";
        }

        if(this.state.cityState === ''){
            formIsValid = false;
            errors["cityState"] = "*Please enter your location (city & state)";
        }

        this.setState({
            errors: errors,
            formIsValid: formIsValid
        });

        return formIsValid;
    }

    render() {
        return (
            <div className="container">
                <div className="container" style={{padding: "0.5em"}}>
                    {this.state.isLoading ?
                        <div id="overlay" className="spinner-border text-info" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        : <div/>
                    }
                    <div className="container" style={{backgroundColor: "#f2f2f2", padding: ".75rem"}}>
                        <div className="row d-flex justify-content-center">
                            <h3 className="page-header">Join us by sharing your details below</h3> <br/>
                        </div>
                        <hr/>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group float-label-control">
                                    <input id="fullName" type="text" className="form-control" placeholder="Full Name (Firstname Lastname)"
                                           onChange={this.handleInputChange} value={this.state.fullName}/>
                                    <div className="errorMsg">{this.state.errors.fullName}</div>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-group float-label-control">
                                    <input id="phoneNumber" type="tel" className="form-control"
                                           placeholder="Phone Number (9876543210)"
                                           pattern="[0-9]{10}" maxLength="10" onChange={this.handleInputChange}
                                           value={this.state.phoneNumber}/>
                                    <div className="errorMsg">{this.state.errors.phoneNumber}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group float-label-control">
                                    <input id="emailId" type="email" className="form-control" placeholder="Email id (something@example.com)"
                                           onChange={this.handleInputChange} value={this.state.emailId}/>
                                    <div className="errorMsg">{this.state.errors.emailId}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group float-label-control">
                                    <input id="cityState" type="text" className="form-control" placeholder="City & State (your location)"
                                           onChange={this.handleInputChange} value={this.state.cityState}/>
                                    <div className="errorMsg">{this.state.errors.cityState}</div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-md-8 inputGroupContainer">
                                <div className="row form-group">
                                    <div className="col-md-2">
                                        <label htmlFor="joinType"><h4>Join as</h4></label>
                                    </div>
                                    <div className="col-md-6">
                                        <select className="form-control" id="joinType"
                                                onChange={this.handleInputChange}
                                                value={this.state.joinType}>
                                            <option value="Select">Select</option>
                                            <option value="Student">Student</option>
                                            <option value="Mentor">Mentor</option>
                                            <option value="StudentPartner">Student Partner</option>
                                            <option value="SocialMediaPartner">Social Media Partner</option>
                                            <option value="ContentCreationPartner">Content Creation Partner</option>
                                            <option value="Moderator">Moderator</option>
                                        </select>
                                    </div>
                                    <div className="errorMsg">{this.state.errors.joinType}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container d-flex justify-content-center">
                    <button type="button" className="btn btn-success" onClick={this.saveDetails}>Join Engg Guru</button>
                </div>
                <br />
                <div className="container d-flex justify-content-center">
                    {
                        this.state.formIsValid ?
                            <div className="successMsg">{this.state.successMsg}</div>
                            :
                            <div className="errorMsg">{this.state.errorMsg}</div>
                    }
                </div>
            </div>
        );
    }
}

RegistrationForm.propTypes = {};

export default RegistrationForm;
